import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import Calendar from 'react-calendar';
import styled from 'styled-components';


const StyledCalendar = styled(Calendar)`

    .react-calendar {
        border: none;
    }

    .react-calendar__month-view__weekdays__weekday {
        abbr {
            text-decoration: none;
        }
    }

    button {
        text-align: center !important;
    } 

    .react-calendar__tile:disabled {
        background-color: white;
        text-decoration: line-through;
    }


    .react-calendar__navigation__prev2-button {
        display: none;
    }
    .react-calendar__navigation__next2-button {
        display: none;
    }

    .react-calendar__navigation__prev-button {
        font-size:30px;
    }
    .react-calendar__navigation__next-button {
        font-size:30px;
    }

    
`

const Calendars = ({subscribersFilter, setSubscribersFilter, setIsFilterOpen, left}) => {

    const ref = useRef(null);

    const [ subscriberFilter, setSubscriberFilter] = useState(subscribersFilter);
    const [ isCustomEnabled, setCustomEnabled ] = useState(subscribersFilter.name === 'Custom Dates');

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);


    const onTodayClick = () => {
        setSubscriberFilter({
            name: 'Last 24 Hours',
            startDay: moment().subtract(24, 'hours'),
            endDay: moment(),
        });
        setCustomEnabled(false);
    }

    const onYesterdayClick = () => {
        setSubscriberFilter({
            name: 'Last 7 Days',
            startDay: moment().subtract(6, 'days').startOf('day'),
            endDay: moment().endOf('day'),
        });
        setCustomEnabled(false);
    }

    const onLastWeekClick = () => {
        setSubscriberFilter({
            name: 'Last 30 days',
            startDay: moment().subtract(30, 'days').startOf('day'),
            endDay: moment().endOf('day'),
        });
        setCustomEnabled(false);
    }


    const getDates = () => {
        return [new Date(subscriberFilter.startDay), new Date(subscriberFilter.endDay)];
        
    }

    const onClickApply = (event) => {
        event.preventDefault();
        setSubscribersFilter(subscriberFilter);
        setIsFilterOpen(false);
        // onApply.mutate();
    }

    const onCustomClick = () => {
        setCustomEnabled(true);
        setSubscriberFilter({
            name: 'Custom Dates',
            startDay: new Date(),
            endDay: new Date(),
        });
    }

    const onCustomRangeSelect = (value, event) => {
        const endDate = value[1] ? moment(value[1]) : moment(value[0]);
        setSubscriberFilter({
            name: 'Custom Dates',
            startDay: value[0],
            endDay: endDate.endOf('day'),
        });
    }

    return  <div ref={ref} className="calendar-dropdown" style={{right: left ? 'auto': 0}}>
        <div className="d-flex">
            <div className="d-flex flex-column category-buttons justify-content-between">
                <div className="d-flex flex-column">
                <button className={subscriberFilter.name === 'Last 24 Hours' ? 'btn btn-primary' : 'btn btn-neutral'}  onClick={onTodayClick}>Last 24 Hours</button>
                <button className={ subscriberFilter.name === 'Last 7 Days' ? 'btn btn-primary' : 'btn btn-neutral'} onClick={onYesterdayClick} >Last 7 Days</button>
                <button className={ subscriberFilter.name === 'Last 30 days' ? 'btn btn-primary' : 'btn btn-neutral'} onClick={onLastWeekClick} >Last 30 days</button>
                {/* <button className={ subscriberFilter.name === 'Last Month' ? "btn btn-outline" : "btn btn-neutral"} onClick={onLastMonthClick}>Last Month</button> */}
                <button className={ subscriberFilter.name === 'Custom Dates' ? 'btn btn-primary d-none d-lg-block' : 'btn btn-neutral d-none d-lg-block'}  onClick={onCustomClick} >Custom Dates</button>
                </div>
                <div className="text-center">
                    <button className="btn btn-primary" onClick={onClickApply}>Apply</button>
                </div>
            </div>
            { isCustomEnabled && <div className="">
                <div className="d-flex" style={{'gap': 5}}>
                        <StyledCalendar 
                            value={getDates()}
                            maxDate={new Date()}
                            style={{border: 'none'}}
                            selectRange={true}
                            returnValue={'range'}
                            onChange={onCustomRangeSelect}
                            isCustom
                            allowPartialRange={true}
                        />
                </div>
            </div>
            }        
            </div>
    </div>
}

export default Calendars;